import React from 'react';
import { useIntl, type MessageDescriptor } from 'react-intl';
import { PROFILE_BANNER_TEXTS, type ProfileBannerText } from 'fym-shared/src/music24/profileBanner';
import { TypedMemo } from '../../../../common/types';
import { Segmented } from '../../../components/primitives/Segmented';
import { profileToolMessages as t } from './profileToolMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Profile; each part uses its own slice of it */
import styles from '../Profile.module.scss';
/* eslint-enable css-modules/no-unused-class */

const LABELS: Readonly<Record<ProfileBannerText, MessageDescriptor>> = {
  none: t.bannerTextNone,
  name: t.bannerTextName,
  release: t.bannerTextRelease,
  link: t.bannerTextLink,
};

interface BannerTextPickerProps {
  value: ProfileBannerText;
  onChange: (value: ProfileBannerText) => void;
}

/**
 * "Text" of the banners tool (design profile-card b1 control): No text, Name, Name + release,
 * Name + release + link. One choice sets both banners. The default is Name + release.
 */
const BannerTextPickerComponent: React.FC<BannerTextPickerProps> = ({ value, onChange }) => {
  const intl = useIntl();
  return (
    <div className="d-flex flex-column gap-1 px-3 pt-3" data-testid="profile-banner-text-picker">
      <span className={styles.eyebrow}>{intl.formatMessage(t.bannerTextLabel)}</span>
      <Segmented
        className="align-self-start"
        ariaLabel={intl.formatMessage(t.bannerTextLabel)}
        value={value}
        onChange={onChange}
        options={PROFILE_BANNER_TEXTS.map((one) => ({ value: one, label: intl.formatMessage(LABELS[one]) }))}
      />
      <span className={styles.meta}>{intl.formatMessage(t.bannerTextHint)}</span>
    </div>
  );
};

export const BannerTextPicker = TypedMemo(BannerTextPickerComponent);
